<template>
  
  <v-container fluid>
    <form>
      <v-text-field :value="dadosPessoais.nome" label="Candidato(a)" disabled></v-text-field>     
      <v-dialog v-model="dlgMembroFamiliar" persistent max-width="800px">
        <v-card>
          <v-card-title>Membro Familiar</v-card-title>
          <v-col cols="12" sm="6">                    
              <v-text-field v-model="membroFamiliar.nome" m required >
                <template #label>
                  Nome do Membro Familiar
                  <span class="red--text"><strong> *</strong></span>
                </template></v-text-field>
          </v-col>
          <v-col cols="2" sm="2">                    
              <v-text-field v-model="membroFamiliar.idade" required>
                <template #label>
                  Idade
                  <span class="red--text"><strong> *</strong></span>
                </template>
              </v-text-field>
          </v-col>
          <v-col cols="12" sm="6" >
              <v-text-field v-model="membroFamiliar.parentesco" maxlength="10" required>
                <template #label>
                  Parentesco
                  <span class="red--text"><strong> *</strong></span>
                </template>
              </v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
              <v-select :items="tiposEstadoCivil" v-model="membroFamiliar.estado_civil" required>
                <template #label>
                  Estado Civil do Membro Familiar
                  <span class="red--text"><strong> *</strong></span>
                </template>
              </v-select>
          </v-col>
          <v-col cols="12" sm="6">
              <v-text-field v-model="membroFamiliar.profissao" maxlength="15" required >
                <template #label>
                  Profissão
                  <span class="red--text"><strong> *</strong></span>
                </template>
              </v-text-field>
          </v-col>
          <v-col cols="12" sm="6">
              <v-text-field v-model="membroFamiliar.renda_bruta" type="number" mask="##.##" required>
                <template #label>
                  Renda bruta mensal - R$
                  <span class="red--text"><strong> *</strong></span>
                </template>
              </v-text-field>
          </v-col>
              <v-card-actions>
                <v-btn @click="salvarMembro" class="mr-4"> Salvar </v-btn>
                <v-btn @click="cancelarMembroFamiliar"> Cancelar </v-btn>
      
              </v-card-actions>          
        </v-card>
      </v-dialog>
      <span class="red--text">Atenção: Não esqueça de incluir o(a) próprio(a) candidato(a) na lista</span>
      <v-card-actions>        
        <v-btn @click="adicionarMembroFamiliar">Adicionar Membro Familiar 
          <v-icon color="primary"> mdi-plus </v-icon>
        </v-btn>
        
      
      </v-card-actions>
      <br />
      <span class="red--text">Observar os meses no edital de abertura do processo seletivo (mínimo 3, máximo 12 meses)</span>
      <v-card max-width="300px">
        <v-col> 
          <v-text-field v-model="periodo" type="number" min="3" max="12" required>
                <template #label>
                  Período (Informar em meses)
                  <span class="red--text"><strong> *</strong></span>
                </template>
      </v-text-field>
        </v-col>
      </v-card>     

      <!-- Data Table -->
      <br />
      <br />      
      <v-data-table 
                :items="listaDeMembros"
                :headers="headersMembros"
                :loading="isLoadingMembros" 
                class="elevation-1"                          
              >
              <template v-slot:item.renda_bruta="{item}">
                  <span v-text="formataEmReais(item.renda_bruta)"></span>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                  <v-btn
                    icon
                    v-if="item.id"                  
                    @click="editarMembro(item)"
                  >
                    <v-icon color="primary"> mdi-pencil </v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    v-if="item.id"                                      
                    @click="excluirMembro(item)"
                  >
                    <v-icon color="error"> mdi-delete </v-icon>
                  </v-btn>
                </template>
      </v-data-table>
      <br />   
      <v-text-field         
        :value="fmtrndbruta"
        label="Renda mensal bruta familiar (Soma de todos os membros do grupo familiar)" 
        class="font-weight-bold"       
        disabled
      ></v-text-field>
      <v-text-field
        :value="fmtrndbrutapercapita"          
        label="Renda per capita (renda mensal bruta total familiar dividido pelo número de todos os membros do grupo familiar)"
        class="font-weight-bold"
        disabled
      ></v-text-field>
       <v-text-field
        :value="fmtrndbrutapercapitareferencial"
        label="Renda per capita (Referencial = 1 salário mínimo vigente)"
        class="font-weight-bold"
        disabled
      ></v-text-field>
      
    
    
    </form>
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="text-h9">Você tem certeza que deseja excluir?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="orange lighten-3" @click="closeDelete">Fechar</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="deleteItemMembroConfirm">OK</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogPeriodo" max-width="500px">
      <v-card>
        <v-card-title class="text-h9">Período informado não é valido.</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>          
          <v-btn color="orange lighten-3" @click="closedialogPeriodo">Fechar</v-btn>          
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>

</template>

<script>
import MembroFamiliar from "@/models/membrofamiliar";
import DadosPessoais from "@/models/dadosPessoais";
import Candidato from "@/models/candidato";
import * as DadosPessoaisService from "@/services/dados-pessoais.service";
import * as MembroFamiliarService from "@/services/membro-familiar.service";
import * as CandidatoService from "@/services/candidato.service";


export default {  
  data() {
    return {
      dadosPessoais: new DadosPessoais(),
      membroFamiliar: new MembroFamiliar('','', '', '', '', '', '', ''),
      candidato: new Candidato(),
      membroFamiliarExclusao: '',
      periodo: 3,
      fmtrndbrutapercapitareferencial: 0,
      fmtrndbruta: 0,
      fmtPeriodoRelatorio: 0,      
      fmtrndbrutapercapita: 0,
      dlgMembroFamiliar: false,
      editandoMembro: false,
      dialogDelete: false,
      dialogPeriodo: false,
      isLoadingMembros: false,
      tiposEstadoCivil: [
        { value: "Solteiro(a)", text: "Solteiro(a)" },
        { value: "Casado(a)", text: "Casado(a)" },
        { value: "União Estável", text: "União Estável" },
        { value: "Separado(a)", text: "Separado(a)" },
        { value: "Divorciado(a)", text: "Divorciado(a)" },
        { value: "Viúvo(a)", text: "Viúvo(a)" },
      ],
      listaDeMembros: [],
      listaDeMembrosPDF: [],
      headersMembros: [        
          {
          text: "Nome do Membro familiar",
          align: "start",
          sortable: true,
          value: "nome",
        },
        {
          text: "Idade",
          align: "start",
          sortable: true,
          value: "idade",
        },
         {
          text: "Parentesco",
          align: "start",
          sortable: true,
          value: "parentesco",
        },               
        {
          text: "Estado Civil",
          align: "start",
          sortable: false,
          value: "estado_civil",
        },
        {
          text: "Profissão",
          align: "start",
          sortable: false,
          value: "profissao",
        },
        {
          text: "Renda Bruta (Mensal)",
          align: "start",
          sortable: false,
          value: "renda_bruta",
        },
        { text: "Ações", value: "actions", sortable: false, align: "center" },
      ],
    };
  },
  mounted() {    
    this.loadDados();
    this.loadMembros();
    this.loadCandidato();
    this.calculoRendaPerCapta();
    this.getSalarioReferenciaPerCapta();
  }  
  ,methods: {
     voltar() {
      this.$emit('voltar')
    },
    salvar() {
      this.$nprogress.start();
      this.$nprogress.done();  
    },
    instanciaMembro(){
      if (this.listaDeMembros.length == 0){
        this.membroFamiliar = new MembroFamiliar('', this.dadosPessoais.nome, '', '', '', '', '');      
        this.membroFamiliar.parentesco = 'Próprio(a) Candidato(a)';
      }else{
        this.membroFamiliar = new MembroFamiliar('','', '', '', '', '', '', '');      
      }
    },
    getSalarioReferenciaPerCapta(){
      MembroFamiliarService.getSalarioReferenciaPerCapta().then( ( res ) => 
        {(this.fmtrndbrutapercapitareferencial = res.data), this.fmtrndbrutapercapitareferencial = this.fmtrndbrutapercapitareferencial * 1,
          this.fmtrndbrutapercapitareferencial = this.fmtrndbrutapercapitareferencial.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});         
        }) ;
    },    
    adicionarMembroFamiliar(){
      if(this.podeAdicionarOuEditar()){
        this.dlgMembroFamiliar = true;
        this.editandoMembro = false;
        this.instanciaMembro();
      }       
    },
    podeAdicionarOuEditar(){
      if (this.periodo >= 3 && this.periodo <=12){
        return true;
      }else{
        this.dialogPeriodo = true;
        return false;
      }      
    },
    cancelarMembroFamiliar() {      
      this.dlgMembroFamiliar = false;
      this.editandoMembro = false;
      this.instanciaMembro();
    },    
    loadDados() {
      this.$nprogress.start();
      DadosPessoaisService.getOne()
        .then(
          (res) =>
            (this.dadosPessoais = new DadosPessoais(
              res.data.id,
              res.data.nome,
              res.data.nomeSocial,
              res.data.cpf,
              res.data.rg,
              res.data.curso,
              res.data.raca
            ))
        )
        .finally(() => this.$nprogress.done());
    },
    loadCandidato(){
      this.$nprogress.start();
      CandidatoService.getOne()
        .then(
          (res) =>
            (this.candidato = new Candidato( 
              res.data.modalidade,
              res.data.classificacao,
              res.data.endereco,
              res.data.contato,
              res.data.dadosPessoais,            
            ))
        )
        .finally(() => this.$nprogress.done());
    },
    loadMembros(){
      this.listaDeMembros = [];
      this.isLoadingMembros = true;    
      this.editandoMembro = false;
      MembroFamiliarService.getMembrosPorCandidato()      
      .then( (res) => {(this.listaDeMembros = res.data);})
      .finally(() => {(this.isLoadingMembros = false);});      
    },       
    salvarMembro(){
      if (this.editandoMembro) {
        this.membroFamiliar.periodo = this.periodo;
        this.$nprogress.start();
        MembroFamiliarService.update(this.membroFamiliar)
          .then((res) => {
            this.$msg.success("Membro salvo com sucesso!");
            this.listaDeMembros.push(res.data);
            this.loadMembros();
            this.calculoRendaPerCapta();
            this.instanciaMembro();
            this.dlgMembroFamiliar = false;
          })
          .finally(() => this.$nprogress.done());

      } else {
        this.membroFamiliar.periodo = this.periodo;
        this.$nprogress.start();
        MembroFamiliarService.create(this.membroFamiliar)
          .then((res) => {
            this.$msg.success("Membro salvo com sucesso!");
            this.listaDeMembros.push(res.data);
            this.loadMembros();
            this.calculoRendaPerCapta();
            this.instanciaMembro();
            this.dlgMembroFamiliar = false;
          })
          .finally(() => this.$nprogress.done());
      }  
    },
    calculoRendaPerCapta(){            
      this.rendaBruta = 0;
      this.renda = 0;
      MembroFamiliarService.getMembrosRendaBrutaPerCapta().then((res) => {        
        this.rendaBruta = res.data;
        this.fmtrndbruta = this.rendaBruta.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});         
      }),
      MembroFamiliarService.getMembrosRendaPerCapta().then((res) => {        
        this.renda = res.data;        
        this.fmtrndbrutapercapita = this.renda.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});         
      }),     
      this.fmtrndbrutapercapitareferencial = this.fmtrndbrutapercapitareferencial.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});          
    },
    editarMembro(membro) {
      if(this.podeAdicionarOuEditar()){
        this.membroFamiliar = membro;
        this.editandoMembro = true;
        this.dlgMembroFamiliar = true;
      }
    },
    excluirMembro(membro){
      this.membroFamiliarExclusao = membro.id;
      this.dialogDelete = true;      
    },
    closeDelete(){
      this.dialogDelete = false;
    },
    closedialogPeriodo(){
      this.dialogPeriodo = false;
    },
    deleteItemMembroConfirm(){
      this.$nprogress.start();      
        MembroFamiliarService.deletar(this.membroFamiliarExclusao)
          .then(() => {
            this.$msg.success("Membro excluído com sucesso!");            
            this.loadMembros();            
            this.calculoRendaPerCapta();
            this.instanciaMembro();
            this.closeDelete();
            this.dlgMembroFamiliar = false;            
          })
          .finally(() => this.$nprogress.done());
    },
    carregaListaPDF(){
      this.listaDeMembrosPDF = this.listaDeMembros;      
    },
    formataEmReais(valor){
      return valor.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});    
    }    
  },
};
</script>


